import { Input as NulogyInput } from "@nulogy/components";
import { useField, useFormikContext } from "formik";
import React from "react";
import styled from "styled-components";

const StyledInput = styled(NulogyInput)`
  input[type="number"] {
    text-align: right;
    ${({ inputWidth }) => `width: ${inputWidth}`}
  }
`;

export default function Input({ field: name, onChange, validate, ...ndsProps }) {
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField({ name, validate });

  const handleChange = (event) => {
    const value = Number.isNaN(event.target.valueAsNumber) ? event.target.value : event.target.valueAsNumber;

    if (onChange) {
      onChange({ setFieldValue, value });
    }
    helpers.setValue(value);
  };

  return <StyledInput errorMessage={meta.error} onChange={handleChange} value={field.value} {...ndsProps} />;
}
